// extracted by mini-css-extract-plugin
export default {"hamburgerMenu":"styles_hamburgerMenu__drtVw","clickableIcon":"styles_clickableIcon__TDP65"};